import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-tools-brush-icon',
  templateUrl: './tools-brush.component.html'
})
export class ToolsBrushComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
